import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={131}
    height={175}
    viewBox="0 0 131 175"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={65.9238}
      cy={100.018}
      r={60.5}
      stroke="url(#paint0_radial_1_316)"
    />
    <circle
      cx={66.4238}
      cy={100.518}
      r={50}
      stroke="url(#paint1_radial_1_316)"
    />
    <circle
      cx={66.4238}
      cy={100.518}
      r={39}
      stroke="url(#paint2_radial_1_316)"
    />
    <circle
      cx={65.9238}
      cy={100.018}
      r={27.5}
      stroke="url(#paint3_radial_1_316)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.1237 55.7554C54.917 48.4654 26.9518 64.6111 19.6617 91.8178C18.2323 97.1525 12.749 100.318 7.41429 98.8889C2.07963 97.4595 -1.08619 91.9761 0.343224 86.6415C10.4921 48.7654 49.424 26.288 87.3001 36.4369C92.6348 37.8663 95.8006 43.3497 94.3712 48.6843C92.9418 54.019 87.4584 57.1848 82.1237 55.7554Z"
      fill="url(#paint4_radial_1_316)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M93.3904 57.1612C96.0725 54.0047 100.806 53.6201 103.962 56.3023C116.469 66.9295 124.424 82.7984 124.424 100.518C124.424 104.66 121.066 108.018 116.924 108.018C112.782 108.018 109.424 104.66 109.424 100.518C109.424 87.3844 103.545 75.6319 94.2493 67.733C91.0928 65.0508 90.7083 60.3177 93.3904 57.1612Z"
      fill="url(#paint5_linear_1_316)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.4239 71.0176C50.1315 71.0176 36.9239 84.2252 36.9239 100.518C36.9239 106.614 38.7623 112.251 41.9134 116.941C44.9933 121.525 43.7737 127.738 39.1893 130.818C34.605 133.898 28.3919 132.679 25.312 128.094C20.0148 120.21 16.9239 110.709 16.9239 100.518C16.9239 73.1795 39.0858 51.0176 66.4239 51.0176C93.762 51.0176 115.924 73.1795 115.924 100.518C115.924 106.04 111.447 110.518 105.924 110.518C100.401 110.518 95.9239 106.04 95.9239 100.518C95.9239 84.2252 82.7163 71.0176 66.4239 71.0176Z"
      fill="url(#paint6_radial_1_316)"
    />
    <circle
      cx={65.4239}
      cy={100.518}
      r={14.5}
      fill="url(#paint7_radial_1_316)"
    />
    <circle
      cx={56.1246}
      cy={98.1246}
      r={0.916667}
      transform="rotate(15.1686 56.1246 98.1246)"
      fill="#0C102B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.5006 99.643C65.8616 99.6285 66.1843 99.4755 66.4196 99.2372L64.5521 99.312C64.8057 99.5307 65.1396 99.6574 65.5006 99.643ZM63.3397 99.3605C63.186 99.0626 63.0933 98.7272 63.079 98.3702L67.8126 98.1806C67.8269 98.5377 67.7614 98.8794 67.632 99.1887C67.2876 100.012 66.4907 100.604 65.5406 100.642C64.5905 100.68 63.7488 100.153 63.3397 99.3605Z"
      fill="black"
    />
    <circle
      cx={74.1246}
      cy={97.1246}
      r={0.916667}
      transform="rotate(15.1686 74.1246 97.1246)"
      fill="#0C102B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.9239 132.018C83.597 132.018 97.9239 117.691 97.9239 100.018C97.9239 82.3445 83.597 68.0176 65.9239 68.0176C48.2508 68.0176 33.9239 82.3445 33.9239 100.018C33.9239 117.691 48.2508 132.018 65.9239 132.018ZM65.9239 123.018C78.6264 123.018 88.9239 112.72 88.9239 100.018C88.9239 87.3151 78.6264 77.0176 65.9239 77.0176C53.2213 77.0176 42.9239 87.3151 42.9239 100.018C42.9239 112.72 53.2213 123.018 65.9239 123.018Z"
      fill="url(#paint8_angular_1_316)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.9239 132.018C83.597 132.018 97.9239 117.691 97.9239 100.018C97.9239 82.3445 83.597 68.0176 65.9239 68.0176C48.2507 68.0176 33.9239 82.3445 33.9239 100.018C33.9239 117.691 48.2507 132.018 65.9239 132.018ZM65.9239 123.018C78.6264 123.018 88.9239 112.72 88.9239 100.018C88.9239 87.3151 78.6264 77.0176 65.9239 77.0176C53.2213 77.0176 42.9239 87.3151 42.9239 100.018C42.9239 112.72 53.2213 123.018 65.9239 123.018Z"
      fill="url(#paint9_linear_1_316)"
    />
    <circle cx={119.424} cy={57.5176} r={2.5} fill="#AB7EEC" />
    <circle cx={125.424} cy={41.5176} r={5.5} fill="#372BE5" />
    <circle cx={19.9238} cy={170.018} r={4} fill="#BF6AFA" />
    <circle cx={7.92383} cy={140.018} r={2} fill="#372BE5" />
    <circle cx={6.92383} cy={153.018} r={1} fill="#171081" />
    <circle cx={115.924} cy={151.018} r={4} fill="#D3A8F0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 0C47.7909 0 46 1.79086 46 4V18C46 20.2091 47.7909 22 50 22H63.5459L65.5 26L67.4541 22H80C82.2091 22 84 20.2091 84 18V4C84 1.79086 82.2091 0 80 0H50Z"
      fill="#6B3BE0"
    />
    <path
      d="M58.2967 15V6.6H59.5687V10.08H63.2407V6.6H64.5127V15H63.2407V11.244H59.5687V15H58.2967ZM68.48 8.136C68.2 8.136 67.964 8.048 67.772 7.872C67.588 7.688 67.496 7.464 67.496 7.2C67.496 6.936 67.588 6.716 67.772 6.54C67.964 6.364 68.2 6.276 68.48 6.276C68.768 6.276 69.004 6.364 69.188 6.54C69.38 6.716 69.476 6.936 69.476 7.2C69.476 7.464 69.38 7.688 69.188 7.872C69.004 8.048 68.768 8.136 68.48 8.136ZM66.092 15V13.896H67.964V10.548C67.964 10.284 67.836 10.152 67.58 10.152H66.26V9.048H67.808C68.304 9.048 68.664 9.164 68.888 9.396C69.12 9.62 69.236 9.98 69.236 10.476V13.896H71.108V15H66.092Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1_316"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(65.9238 24.0176) rotate(90) scale(146.5)"
      >
        <stop stopColor="#454661" stopOpacity={0.32} />
        <stop offset={1} stopColor="#3F58D9" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1_316"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(66.4238 37.5996) rotate(90) scale(121.283)"
      >
        <stop stopColor="#454661" stopOpacity={0.32} />
        <stop offset={1} stopColor="#3F58D9" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_1_316"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(66.4238 51.3045) rotate(90) scale(94.8648)"
      >
        <stop stopColor="#454661" stopOpacity={0.32} />
        <stop offset={1} stopColor="#3F58D9" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_1_316"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(65.9238 65.1324) rotate(90) scale(67.2459)"
      >
        <stop stopColor="#454661" stopOpacity={0.32} />
        <stop offset={1} stopColor="#3F58D9" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_1_316"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(88.5942 31.6073) rotate(144.976) scale(135.753 135.753)"
      >
        <stop stopColor="#9141E0" />
        <stop offset={0.17} stopColor="#4E41E0" />
        <stop offset={1} stopColor="#090072" />
      </radialGradient>
      <linearGradient
        id="paint5_linear_1_316"
        x1={84.9239}
        y1={51.0176}
        x2={122.424}
        y2={134.518}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2E22A9" />
        <stop offset={1} stopColor="#1A1571" />
      </linearGradient>
      <radialGradient
        id="paint6_radial_1_316"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(86.9239 57.0176) rotate(115.615) scale(80.9568 80.9568)"
      >
        <stop stopColor="#7E42E0" />
        <stop offset={0.5} stopColor="#2521DD" />
        <stop offset={1} stopColor="#020073" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_1_316"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.5458 90.6152) rotate(94.9697) scale(24.4945)"
      >
        <stop stopColor="#E7A178" />
        <stop offset={1} stopColor="#E35CBA" />
      </radialGradient>
      <radialGradient
        id="paint8_angular_1_316"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.6068 78.164) rotate(94.9697) scale(54.0569)"
      >
        <stop stopColor="#A154CF" />
        <stop offset={0.15} stopColor="#3A40CF" />
        <stop offset={1} stopColor="#3122C0" />
      </radialGradient>
      <linearGradient
        id="paint9_linear_1_316"
        x1={51.9238}
        y1={76.0176}
        x2={74.4238}
        y2={135.518}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0C01F8" stopOpacity={0.52} />
        <stop offset={0.470359} stopColor="#1000C6" stopOpacity={0.4018} />
        <stop offset={0.817159} stopColor="#3B11B2" stopOpacity={0.44077} />
        <stop offset={1} stopColor="#FFC700" stopOpacity={0.46} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgComponent;
